<template>
	<div class="Main_wrapper" style="margin-bottom: 0px;">
		<!-- Main_wrapper -->
		

		<div class="w1">
			<!-- w1 -->
<el-skeleton :rows="20" :loading="loadingMask" animated >

			<div class="zjzj_list2">
				<!-- zjzj_list2 -->
				<item class="item  block" v-for="(item,index) in topDataList" v-if="index<4">
					<!-- item -->
					<div class="item_inner">
						<div class="pic" style="width: 180px;height: 240px;"><img v-bind:src="item.expertphotocontent" /></div>
						<div class="list">
							<div>
								<h2>{{item.expertname}}</h2>
								<h3 :title="item.expertintroduce">{{item.expertintroduce}}</h3>
							</div>
							<div v-if="item.researchfield&&item.researchfield.split('|').length>0">
								<span v-if="tagindex<2" v-for="(tag,tagindex) in item.researchfield.split('|')" href="javascript:;" class="T-keywords" style="max-width: 158px;margin: 0px 4px;overflow: hidden;text-overflow: ellipsis;" :title="tag">{{tag}}</span>
							</div>
						</div>
					</div>

				</item><!-- /item -->
				
			</div><!-- /zjzj_list2 -->
</el-skeleton>

		</div><!-- /w1 -->



		<!-- <div class="m_b1"></div> -->
		


		<div class="bg_box">
			<!-- /bg_box -->
			<div class="w1">
				<!-- w1 -->



				<div class="zjzj_photowall">
					<!-- zjzj_photowall -->
					<item class="item" style="min-width: 180px;" v-for="(item,index) in resultDataList">
						<!-- item -->
						<iteminner style="width: 180px;height: 330px;">
							<div class="pic " name="D_pw_pic" style="width: 180px;height:240px;" @mouseover="showDetailId=item.id"><img  v-bind:src="item.expertphotocontent" /></div>
							<div class="list ">
								<div>
									<h2>{{item.expertname}}</h2>
								</div>
								<div>
									<div v-if="item.researchfield&&item.researchfield.split('|').length>0">
										<span v-if="tagindex<2" v-for="(tag,tagindex) in item.researchfield.split('|')" href="javascript:;" class="T-keywords" style="width: 75px;margin: 0px 4px;overflow: hidden;text-overflow: ellipsis;" :title="tag">{{tag}}</span>
									</div>
								</div>
							</div>
							<div class="pw_detail " style="display: block;"  @mouseleave="showDetailId=''"  v-show="showDetailId==item.id">
								<h1>“</h1>
								<h2>{{item.expertname}}</h2>
								<h3 style="-webkit-line-clamp: 8;" :title="item.expertintroduce">{{item.expertintroduce}}</h3>
							</div>
						</iteminner>
					</item><!-- /item -->
					
				</div><!-- /zjzj_photowall -->





				<div class="m_b1"></div>



				<el-row class="pagediv">
					<el-pagination
								@size-change="changePageSize"
								@current-change="changeSearchPage"
								:current-page="pageNum"
								:page-sizes="[12, 18, 24]"
								:page-size="pageSize"
								layout="total, sizes, prev, pager, next, jumper"
								:total="totalResultCount">
							</el-pagination>
				</el-row>


			</div><!-- /w1 -->
		</div><!-- /bg_box -->



	

	</div><!-- /Main_wrapper -->
</template>

<script>
	export default {
		data() {
			return {
				loadingMask: true,
				colid:'78401ce0b06e4fbf8e77f4cff29235e8',
				pageNum: 1,
				pageSize: 12,
				totalResultCount: 0,
				resultDataList: [],
				topDataList:[],
				showDetailId:'',
			}
		},
		created:function(){
			
		},
		mounted:function(){
			document.title='专家-中经专网';
			this.$track([
				['pagetype','专家列表'],
				['reqtype','2'],
				['column',this.colid]
			]);
			this.getTopfnc();
			this.searchfnc();
			
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
		},
		methods: {
			getTopfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'expert/selectBySortTopExpertsInfos',
						responseType: 'json',
						params: {
							top:4,
						},
					})
					.then(function(response) {
						_this.topDataList = response.data.data.data;
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			searchfnc: function() {
				let _this = this;
				// _this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'expert/selectPageList',
						responseType: 'json',
						params: {
							top:4,
							iStartNum:this.pageNum,
							iPageSize: this.pageSize,
						},
					})
					.then(function(response) {
						_this.resultDataList = response.data.data.data.data;
						_this.totalResultCount = response.data.data.data.totalcount;
						// _this.loadingMask = false;
					})
					.catch(function(error) {
						// _this.loadingMask = false;
						console.log(error);
					});
			},
			changePageSize:function(pagesize){
				this.pageSize=pagesize;
				this.searchfnc();
			},
			changeSearchPage: function(page) {
				this.pageNum = page;
				this.searchfnc();
			},
			// getuserinfofnc: function() {
			// 	let _this = this;
			// 	this.$http({
			// 			method: 'get',
			// 			url: 'UserInfo/getUserInfo',
			// 			responseType: 'json',
			// 			params: {
							
			// 			},
			// 		})
			// 		.then(function(response) {
			// 			_this.getTopfnc();
			// 			_this.searchfnc();
			// 			// debugger;
			// 			var tempinfo={
			// 				userAccountID:response.data.data.data.userAccountID,
			// 				username:response.data.data.data.username,
			// 				usertype:response.data.data.data.usertype,
			// 				outUrl:response.data.data.data.outUrl
			// 			}
			// 			_this.$cookies.set('userinfo',tempinfo);
			// 		})
			// 		.catch(function(error) {
			// 			console.log(error);
			// 		});
			// },
		}
	}
</script>

<style>
	.zjzj_list2 .item .list h3{
		-webkit-line-clamp: 4;
	}
	.zjzj_list2 .item:nth-child(odd) {
	    padding-right: 24px;
	}
	.zjzj_list2 .item:nth-child(even) {
	    padding-left: 24px;
	}
	.zjzj_photowall .item:nth-child(5n) iteminner {
	    margin-right: 24px;
	}
	.zjzj_photowall .item:nth-child(6n) iteminner {
	    margin-right: 0px;
	}
	.zjzj_photowall .T-keywords{
		background:#F2F2F2;
		color: #A1A4AB!important;
	}
</style>
